import { render, staticRenderFns } from "./v-data.vue?vue&type=template&id=48d01650&"
import script from "./v-data.vue?vue&type=script&lang=js&"
export * from "./v-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports